import { useState, useEffect } from "react";

function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const setOffline = () => setIsOffline(true);
    const setOnline  = () => setIsOffline(false);
    window.addEventListener("offline", setOffline);
    window.addEventListener("online", setOnline);
    return () => {
      window.removeEventListener("offline", setOffline);
      window.removeEventListener("online", setOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div style={styles.banner} role="alert" aria-live="assertive">
      <span style={styles.icon} aria-hidden="true">📡</span>
      <span style={styles.text}>
        You're offline. Please check your internet connection.
      </span>
    </div>
  );
}

const styles = {
  banner: {
    position: "fixed",
    bottom: "1rem",
    left: "50%",
    transform: "translateX(-50%)",
    background: "#1a1a2e",
    color: "#fff",
    padding: "12px 24px",
    borderRadius: "50px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "0.9rem",
    fontWeight: 500,
    zIndex: 9999,
    boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
    animation: "slideUp 0.3s ease",
  },
  icon: { fontSize: "1.1rem" },
  text: { whiteSpace: "nowrap" },
};

export default OfflineBanner;
